import styled from 'styled-components';
import InfoBox from 'components/InfoBox';
import Text from 'components/base/Text';
import Icon from 'components/base/Icon';
import { useHistory } from 'react-router-dom';
import AppRouter from 'common/AppRouter';
import _ from 'lodash';
import { StyledSettingBox } from '../SettingsModal.style';
import { PM_PROVIDERS } from 'common/constants/constants';
import usePmProvider from 'components/hooks/PM/usePmProvider';
import { LBButton } from '@linearb/buzz';


const StyledText = styled(Text)`
  text-align: left;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 28rem;
  & svg#LinkArrow {
    margin-left: 0.5rem;
    width: 1rem;
    height: 1rem;
  }
`;

const EmailDigestCTA = ({ onClick = _.noop }) => {
  const history = useHistory();
  const pmProvider = usePmProvider();
  const supportedPmProviders = [PM_PROVIDERS.JIRA];

  const onClickCTA = () => {
    history.push(
      `${AppRouter.EMAIL_PREFERENCES_SETTINGS.path}?isOrgSettings=true`
    );
    onClick();
  };

  if (!supportedPmProviders.includes(pmProvider)) return null;

  return (
    <StyledSettingBox>
      <InfoBox width='30rem' iconAlign='center' padding='x-small' mt='none'>
        <StyledText size='normal' align='center'>
          Email Digest is now available!
          <LBButton variant='outline' onClick={onClickCTA}>
            Sign Up
            <Icon name='LinkArrow' />
          </LBButton>
        </StyledText>
      </InfoBox>
    </StyledSettingBox>
  );
};

export default EmailDigestCTA;
